import { useEffect, useState } from "react";
import { setDeepLinkCookieFromUrlParams } from "@utils/domainUtils";

type DeepLinkFlagFromUrlParamStatus = "in-progress" | "completed";

// TODO [LOWA-30534] This is only for old flow
export const useSetDeepLinkFromUrlParam = () => {
    const [status, setStatus] = useState<DeepLinkFlagFromUrlParamStatus>(
        "in-progress"
    );
    useEffect(() => {
        const urlParams = new URLSearchParams(document.location.search);
        setStatus("in-progress");
        setDeepLinkCookieFromUrlParams(urlParams);
        setStatus("completed");
    }, []);
    return status;
};
